import { createStore } from 'vuex'
import { userState as UserModule } from '@/shared/state/user-data';
import { benchmarkData as BenchmarkModule } from '@/modules/benchmark/benchmark-data';
import { benchmarkReportState as BenchmarkReportModule } from '@/modules/benchmark-report/benchmark-report-data';
import { mapsState as MapsModule } from '@/modules/maps/maps-data';
import { dashboardState as DashboardModule } from '@/modules/dashboard/dashboard-data';
import { adminState as AdminModule } from '@/modules/admin/admin-data'
import { reportState as ReportModule } from '@/modules/report/report-data';
import { downloadState as DownloadModule } from '@/modules/download/download-data';
import { powerbiExportState as powerbiExportModule } from '@/modules/powerbi-export/powerbi-export-data';


const store = createStore({
  strict: true, // process.env.NODE_ENV !== 'production',
  state: {
    isSidebarMinimized: false,
    showLoading: false,
    error: null,
    report: null,
    user: UserModule.state
  },
  mutations: {
    updateSidebarCollapsedState(state, isSidebarMinimized) {
      state.isSidebarMinimized = isSidebarMinimized
    },
    setAccessToken(state, token) {
      state.user.jwt = token;
    },
    toggleAuthenticated(state) {
      state.user.authenticated = !state.user.authenticated
    },
    setUserDataToSession(state, data) {
      // state.user.auth = data;
      sessionStorage.setItem('user', JSON.stringify(data))
    },
    setShowLoading(state) {
      state.showLoading = !state.showLoading;
    },
    setError(state, error) {
      state.error = error
    },
  },
  actions: {
    raiseError(context, error) {
      context.commit('setError', error)
    },
    showLoadingAnimation(context, show) {
      if (show !== this.state.showLoading) {
        context.commit('setShowLoading')
      }
    }
  },
  modules: {
    user: UserModule,
    dashboard: DashboardModule,
    benchmark: BenchmarkModule,
    benchmarkReport: BenchmarkReportModule,
    admin: AdminModule,
    report: ReportModule,
    maps: MapsModule,
    download: DownloadModule,
    powerbiExport: powerbiExportModule,
    schools: UserModule
  }
});

export default store;
